<template>
  <modal class="confirmModal" :show="isConfirmOpen" :closeModal="closeModal">
    <h1 slot="header" v-html="header"></h1>
    <div slot="body" v-html="message"></div>
    <div slot="footer">
      <button class="btn btn02" @click.stop="handleClick()">
        {{ btnName.close || $t('common.cancel') }}
      </button>
      <button class="btn btn01" @click.stop="handleClick(true)" ref="btn">
        {{ btnName.confirm || $t('common.confirm') }}
      </button>
    </div>
  </modal>
</template>

<script>
import Modal from '@/components/modules/common/Modal';
import { mapActions, mapGetters } from 'vuex';

export default {
  watch: {
    isConfirmOpen: function (val) {
      if (val) {
        this.buttonFocus();
      }
    },
  },
  components: {
    Modal,
  },
  data() {
    return {};
  },
  computed: {
    ...mapGetters('modal', ['isConfirmOpen', 'header', 'message', 'callback', 'closeCallback', 'btnName']),
  },
  methods: {
    ...mapActions('modal', ['closeModal']),
    handleClick(callCallback) {
      if (callCallback && typeof this.callback === 'function') {
        this.callback();
      } else if (typeof this.closeCallback === 'function') {
        this.closeCallback();
      }
      this.closeModal();
    },
    buttonFocus() {
      setTimeout(() => {
        const btn = this.$refs.btn;
        if (btn) {
          btn.focus();
        }
      }, 100);
    },
  },
  mounted() {
    this.buttonFocus();
  },
};
</script>
